<template>
    <div class="poweredby-container">
        <img class="logo" :src="require('@/assets/default/images/teknisa.svg')">
    </div>
</template>
<script >
export default {
    name: 'PoweredBy'
}
</script>
<style lang="less" scoped>
.poweredby-container {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background:#ccc;
    height: 30px;
    display: block;
    text-align: center;
    color: white;
    span {
        display: block;
        margin: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
        background-color: #565656;
        color: transparent;
        text-shadow: 2px 2px 3px rgba(255,255,255,0.5);
        -webkit-background-clip: text;
        -moz-background-clip: text;
        background-clip: text;
        font-weight: bold;
    }
}
</style>
